<style>
    .ly-product-total{
        border:1px solid #dfe6ec;
        border-top: 0;
        
    }
    .ly-product-total-item{
        color: #48576a;
        font-size: 12px;
        padding: 8px 12px;
        border-left: 1px solid #dfe6ec;   
    }
</style>
<template>
    <div class="p20">
        <!-- 头部按钮部分 start -->
        <div class="el-row ly-bill-title">
            <el-col :span="12">
                <h1 style="padding-top:5px;">新建三包理赔单</h1>
            </el-col>
            <el-col :span="12" class="tr">
                <el-button type="primary" @click="addQuote" size="small">
                    选择引用登记单
                </el-button>
                <el-button type="primary" @click="submit" size="small" :loading="submitLoad">
                    <i class="fa fa-save" v-if="!submitLoad"></i>&nbsp;提交
                </el-button>
                <ly-router-button size="small">
                    <i class="fa fa-chevron-left"></i>&nbsp;返回
                </ly-router-button>
            </el-col>
        </div>
        <!-- 头部按钮部分 end -->
        <!-- 表单列表 start -->
        <el-card class="box-card mt15">
            <Ly-search-form 
                :config="formConfig" 
                :rules="formRules"
                :is-search="false"
                label-width="120px"
                ref="searchForm">
            </Ly-search-form>
        </el-card>
        <!-- 表单列表 end -->
        <!-- 商品选择组件 start -->
        <el-card class="box-card mt15" ref="productCard">
            <ly-product-table 
                ref="productTable"
                :is-add="false"
                :is-delete="false"
                :thead-config="productConfig"
                v-model="submitForm.productList">
                <el-col :span="24" class="ly-product-total">
                    <el-col :offset="12" :span="6" class="ly-product-total-item">
                        总贴损金额: {{totalTiesunAmount}}
                    </el-col>
                    <el-col :span="6" class="ly-product-total-item">
                        总理赔金额: {{totalLipeiAmount}}
                    </el-col>
                </el-col>
            </ly-product-table>
        </el-card>
        <!-- 商品选择组件 end -->
        <Ly-quote ref="tgquote" register-id="" ref-id="" @complete="quoteComplete"></Ly-quote>
    </div>
</template>
<script>
    /**
     * 三包理赔的新增页面
     * @author zjs
     * @time 2017-09-18
     */
    import AddFormConfig from './add-form'
    import AddProductConfig from './add-product'
    import AddRulesConfig from './rules'
    import LySearchForm from '@c/search-form'
    import LyProductTable from '@c/product-table'
    import LyQuote from '@c/quote'
    import LyRouterButton from '@c/router-button'

    import {mapGetters, mapActions} from 'vuex'
    export default {
        mixins: [
            AddFormConfig, 
            AddProductConfig,
            AddRulesConfig
        ],
        components: {
            LySearchForm,
            LyQuote,
            LyProductTable,
            LyRouterButton
        },
        computed: {
            ...mapGetters([
                'userInfo'     
            ]),
            ...mapGetters('bill', [
                'copyInfo'
            ]),
            // 总的贴损金额，顺便将总的理赔金额 在这计算了
            totalTiesunAmount () {
                let total = 0 
                let lipei = 0
                this.submitForm.productList.forEach(function (el) {
                    // 计算总的贴损金额
                    if (el.tiesun_amount && !isNaN(el.tiesun_amount)) {
                        total = (parseFloat(total) + parseFloat(el.tiesun_amount)).toFixed(2)
                    }
                    // 计算理赔总金额
                    if (el.lipei_amount && !isNaN(el.lipei_amount)) {
                        lipei = (parseFloat(lipei) + parseFloat(el.lipei_amount)).toFixed(2)
                    }
                }, this)
                this.totalLipeiAmount = lipei
                return total
            }
        },
        data () {
            return {
                submitLoad: false, // 提交按钮的状态标识
                submitForm: {
                    uuid: '',
                    productList: []
                }, // 提交的表单数据
                totalLipeiAmount: 0 // 总的理赔金额
            }
        },
        mounted () {
            // 有复制数据的时候
            if (this.copyInfo && this.copyInfo.path && this.copyInfo.path === 'checkin') {
                this.queryEditData(this.copyInfo.id)
            } else {
                // 设置UUID
                this.submitForm.uuid = this.$utils.createUUID()
                this.initData()
            }
        },
        watch: {
            userInfo () {
                this.initData()
            },
            '$route' (to, from) {
                // 清空之前的输入
                if (to.name === 'CheckoutAdd') {
                    this.$refs['searchForm'].resetForm()
                    this.$refs['productTable'].resetList()
                    // 初始化数据
                    this.initData()
                }
            }
        },
        methods: {
            ...mapActions('bill', [
                'clearCopyInfo'
            ]),

            /**
             * 获取要修改的数据
             */
            queryEditData (id) {
                this.$api.queryArr(['api/sanbaoLp', 'edit'], null, [id]).then((rs) => {
                    this.submitForm = rs
                    // 设置表单中的回填数据
                    this.$refs['searchForm'].initBindFormData(rs)
                    // 设置UUID
                    this.submitForm.uuid = this.$utils.createUUID()
                     // 清空复制
                    this.clearCopyInfo()
                    // 取消加载
                    setTimeout(() => {
                        this.loading = false
                    }, 100)
                }).catch((error) => {
                    // 取消加载
                    this.loading = false
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            },
            /**
             * 初始化的数据设置
             */
            initData () {
                // 初始设置制作单人
                this.$refs['searchForm'].initBindFormData({
                    zhidan_name: this.userInfo.name
                })
            },
            /**
             * 引用单据的监听
             */
            addQuote () {
                let data = this.$refs['searchForm'].bindForm
                if (data.customer && data.customer.customer_id > 0) {
                    this.$refs['tgquote'].open(data.customer.customer_id)
                } else {
                    this.$message({
                        message: '请先选择客户信息',
                        type: 'warning'
                    })
                }
            },
            /** 
            * 引用单号的选择
            */
            quoteComplete (quote) {
                // 设置登记单ID
                this.$refs['searchForm'].setFieldValue('dengji_id', quote.dengji_id)
                // 设置表单回填
                this.$refs['searchForm'].initBindFormData(quote)
                // 设置货品回填
                this.$refs['productTable'].replaceProductList(quote.productList)
            },
            submit () {
                // let productList = this.$refs['productTable'].getProductData()
                if (this.$refs['searchForm'].validateForm()) {
                    if (this.submitForm.productList && this.submitForm.productList.length > 0) {
                        // 获得得查询的字段
                        this.submitForm = Object.assign(this.submitForm, this.$refs['searchForm'].bindForm)
                        // 货品验证
                        let productMsg = this.validateProduct(this.submitForm.productList, this.submitForm.lipei_manner)
                        // 货品验证不通过的情况
                        if (productMsg.length > 0) {
                            this.$alert(productMsg, '货品录入提示', {
                                confirmButtonText: '确定'
                            })
                        } else {
                            this.$confirm('提交后本单据即为审核状态，同时将立即生成对应销售单据，后续由商务处理。确认要提交?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                this.submitLoad = true
                                // 表单中写入货品列表
                                // this.submitForm['productList'] = productList
                                // 提交数据
                                this.$api.create('api/sanbaoLp',this.submitForm).then((rs) => {
                                    this.$alert('数据提交成功', '新增', {
                                        confirmButtonText: '确定',
                                            callback: action => {
                                                this.submitLoad = false
                                                // 跳转到详情页面
                                                this.$router.push('/bill/checkout/info/' + rs.id)
                                            }
                                    });
                                    // 更新UUID
                                    this.submitForm.uuid = this.$utils.createUUID()
                                }).catch((error) => {
                                    this.submitLoad = false
                                    this.$message({
                                        message: error,
                                        type: 'warning'
                                    })
                                })
                            })
                        }
                    } else {
                        this.$message({
                            message: '请添加货品',
                            type: 'warning'
                        })
                    }
                } else {
                    this.$message({
                        message: '请将信息填写完整',
                        type: 'warning'
                    })
                }
            }
        }
    }
</script>